/** @jsx jsx */
import { jsx, keyframes } from '@emotion/react'
import { useState, useEffect, useCallback } from "react"
import LinkItem from "../../../components/LinkItem"
import { useStaticQuery, graphql } from "gatsby"
import styled from '@emotion/styled';
import { GatsbyImage, getImage, withArtDirection } from "gatsby-plugin-image";
import * as breakpoint from '../../../styles/breakpoints.module.scss';
import { useLocalization } from 'gatsby-theme-i18n';

const floating = keyframes`
  0% {
    transform: translatey(0px);
  }
  50% {
    transform: translatey(-20px);
  }
  100% {
    transform: translatey(0px);
  }
`

const IngameItem = ( props ) => {
  let { children, componentLoaded } = props
  let { t, currentLocaleObj } = useLocalization();
  let [ imgLoaded, setImgLoaded ] = useState(0);


  const data = useStaticQuery(graphql`
  query IngameItem {
    visual_1 : file(sourceInstanceName: {eq: "images"}, relativePath: {eq: "content/visual_mainHeadline_ingame1.png"}) {
      childImageSharp {
        gatsbyImageData(
          layout: FULL_WIDTH
          placeholder: NONE
        )
      }
    }
    visual_2 : file(sourceInstanceName: {eq: "images"}, relativePath: {eq: "content/visual_mainHeadline_ingame2.png"}) {
      childImageSharp {
        gatsbyImageData(
          layout: FULL_WIDTH
          placeholder: NONE
        )
      }
    }
    visual_2_mobile : file(sourceInstanceName: {eq: "images"}, relativePath: {eq: "content/visual_mainHeadline_ingame2_mobile.png"}) {
      childImageSharp {
        gatsbyImageData(
          layout: FULL_WIDTH
          placeholder: NONE
        )
      }
    }
  }
`);

const checkLoaded = useCallback(() => {
  if(document)
  {
    if(document.querySelectorAll(`#ingameItemWrapper img`).length > 0)
    {
      
      let imageArr = document.querySelectorAll(`#ingameItemWrapper img`)
      let loadedImage =  Array.from(imageArr).filter((element) => {
        return element.complete;
      }).length;
      setImgLoaded(loadedImage);

      if(loadedImage >= 2)
      {
        componentLoaded();
      }
    }
  }
},[componentLoaded])

useEffect(() => {
  checkLoaded();
},[checkLoaded])



  return(
    <IngameItemsWrapper id="ingameItemWrapper">
      <IngameItem1>
        <GatsbyImage image={getImage(data.visual_1)} alt={t('home.ingame_item.title')}  onLoad={() => {
          if(imgLoaded+1 >= 2)
          {
            componentLoaded();
          }
          else {
            setImgLoaded(imgLoaded+1);
          }
        }}/>
      </IngameItem1>
      <IngameItem2>
        <GatsbyImage image={
          withArtDirection(getImage(data.visual_2), [
            {
              media: `(min-width: ${breakpoint.smMin})`,
              image: getImage(data.visual_2),
            },
            {
              media: `(max-width: ${breakpoint.xsMax})`,
              image: getImage(data.visual_2_mobile),
            }
          ])} alt={t('home.ingame_item.title')} onLoad={() => {
          if(imgLoaded+1 >= 2)
          {
            componentLoaded();
          }
          else {
            setImgLoaded(imgLoaded+1);
          }
        }}/>
      </IngameItem2>
      
      <Stamp fade to={`/${currentLocaleObj.prefix}/ingame-item/`}>
        {children}
      </Stamp>
    </IngameItemsWrapper>
  );
}

export default IngameItem;

const IngameItemsWrapper = styled.div`
  position:relative;
  width:100%;

`

const IngameItem1 = styled.div`
  width:665px;
  height:450px;
  position:absolute;
  bottom:-176px;
  left:-295px;

  opacity:0;
  transform:translateX(-30px);
  transition:all .5s;
  transition-delay:1.1s;

  > *{
    animation: ${floating} 6s ease-in-out infinite;
  }

  .loaded &{
    opacity:1;
    transform:none;
  }

  @media only screen and (max-width: 1440px){
    width:46.1vw;
    height: auto;
    bottom:-120px;
  }
  @media only screen and (max-width: 1280px){
    bottom:-90px;
  }
  @media only screen and (max-width: ${breakpoint.smMax}){
    width:384px;
    left:-129px;
    bottom:-88px;
  }
  @media only screen and (max-width: ${breakpoint.xsMax}){
    width:230px;
    height:155px;
    bottom:-88px;
    left:-75px;
  }
`;

const IngameItem2 = styled.div`
  width:218px;
  height:163px;
  position:absolute;
  bottom:-56px;
  right:148px;

  opacity:0;
  transform:translateX(30px);
  transition:all .5s;
  transition-delay:1.2s;

  .loaded &{
    opacity:1;
    transform:none;
  }

  @media only screen and (max-width: ${breakpoint.smMax}){
    bottom:-70px;
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    height:74px;
    width:127px;
    bottom:-90px;
    right:auto;
    left:44px;
  }
`;


const Stamp = styled(LinkItem)`
  display:block;
  width: 184px;
  height: 184px;
  background: linear-gradient(180deg, #D00F31 0%, #F50057 100%);
  box-shadow: 0px 5px 8px -4px rgba(239, 3, 81, 0.5);
  box-shadow: 0px 5px 8px -4px rgba(239, 3, 81, 0.5);
  border-radius:92px;
  display:flex;
  justify-content:center;
  flex-direction: column;
  position:absolute;
  text-decoration:none;

  bottom:40px;
  right:40px;


  transform: translate(50%,50%);

  transition: all 1.3s;


  opacity:0;
  transition:all .5s;
  transition-delay:.9s;

  .loaded &{
    opacity:1;
  }


  &:hover{
    width:192px;
    height:192px;
    background: linear-gradient(180deg, #F50057 0%, #F50057 100%);
    border: 4px solid rgba(255, 255, 255, 0.5);
    box-shadow: 0px 5px 8px -4px rgba(239, 3, 81, 0.5);
  }

  &:active{
    width:192px;
    height:192px;
    background: linear-gradient(180deg, #D00F31 0%, #D00F31 100%);
    border: 4px solid rgba(255, 255, 255, 0.5);
    box-shadow: 0px 5px 8px -4px rgba(239, 3, 81, 0.5);

  }

  span{
    color: #FCFCFF;
    display:block;
    text-align:center;

    &:nth-of-type(1){
      font-size: 14px;
      line-height: 20px;
      margin-bottom:10px;
      font-weight:900;
    }
    &:nth-of-type(2){
      font-size: 22px;
      line-height: 32px;
      margin-bottom:0px;
      font-weight:900;

      html[lang=de] &,html[lang=fr] &{
        font-size: 18px;
        line-height: 28px;
      }
    }
    &:nth-of-type(3){
      font-size: 22px;
      line-height: 32px;
      font-weight:900;

      html[lang=de] &,html[lang=fr] &{
        font-size: 18px;
        line-height: 28px;
      }
    }
    &:nth-of-type(4){
      margin-top:8px;
      font-size: 12px;
      line-height: 16px;
    }
  }

  @media only screen and (max-width: ${breakpoint.smMax}){
    bottom:0;
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    width: 144px;
    height: 144px;
    bottom:-6px;

    &:hover,&:active{
      width:152px;
      height:152px;
    }

    span{
      &:nth-of-type(1){
        font-size: 12px;
        line-height: 16px;
        margin-bottom:6px;

      }

      &:nth-of-type(2){
        font-size: 18px;
        line-height: 24px;

        html[lang=de] &,html[lang=fr] &{
          font-size: 15px;
          line-height: 22px;
        }
        
      }
      &:nth-of-type(3){
        font-size: 18px;
        line-height: 24px;

        html[lang=de] &,html[lang=fr] &{
          font-size: 15px;
          line-height: 22px;
        }
      }

      &:nth-of-type(4){
        margin-top:6px;
        font-size: 10px;
        line-height: 16px;
      }
    }
  }
`

